import { useCallback, useEffect, useState } from "react";

import stringToHtmlParser from 'html-react-parser';
import { Select as TWSelect, Col, Label, Row } from "twyne-new.ui";

import Option from "./Option";
import OptionProperties from "./Properties";

function getContainerStyle(horizontalPadding) {
  const containerStyle = {}
  if (horizontalPadding) {
    containerStyle.paddingLeft = `${horizontalPadding}`;
    containerStyle.paddingRight = `${horizontalPadding}`;
  }

  return containerStyle;
}

function ConsentText({ consentTextActive, consentText }) {
  if (!consentTextActive) return null;

  return <Label>
    {stringToHtmlParser(consentText || '')}
  </Label>
}

function Select({ data }) {
  const { answers = [], templateCols = 2, templateRows = 2, templateType } = data
  const selectOptions = templateType === 'only-dropdown' ? answers : answers.slice(templateCols * templateRows)
  const isRenderSelect = templateType !== 'only-buttons' && selectOptions.length > 0

  if (!isRenderSelect) return null;

  return <Row className="mt-2 flex justify-center" >
    <Col size="6">
      <TWSelect options={selectOptions?.map(answer => ({ label: answer.answer, value: answer.key }))} />
    </Col>
  </Row>
}

function Options({ disabled, onClickOption, data }) {
  const [rows, setRows] = useState([]);
  const { answers = [], templateCols = 2, templateRows = 2, templateType, buttonPadding = 3, horizontalPadding } = data;
  const isRenderOption = templateType !== 'only-dropdown'
  const answerLength = answers.length;

  const genarateRows = useCallback(() => {
    if (answerLength > 0) {
      const answersRows = templateType === 'only-buttons' ? answers : answers.slice(0, templateCols * templateRows);
      const rows = answersRows.reduce((acc, answer, index) => {
        const row = Math.floor(index / templateCols);
        if (!acc[row]) acc[row] = [];
        acc[row].push({ ...answer, index });
        return acc;
      }, [])

      setRows(rows);
    }
  }, [answerLength, templateCols, templateRows, answers, templateType])

  useEffect(() => {
    genarateRows()
  }, [genarateRows])

  if (!isRenderOption) return null;

  const containerStyle = getContainerStyle(horizontalPadding);

  return <div style={containerStyle}>
    {rows.map((row, index) => <Row key={index}>
      {row.map((answer, index) => <Col size='max' key={index}>
        <Option answer={answer} index={index} onClick={onClickOption} buttonPadding={buttonPadding} disabled={disabled} />
      </Col>)}
    </Row>)}
  </div>
}

export default function ButtonAndDropdown({ data, onChange, disabled }) {
  const { answers = [], question, consentTextActive, consentPosition, consentText } = data;
  const isConsentBefore = consentPosition === 'before';
  const [selectedAnswer, setSelectedAnswer] = useState(null)

  const handleClickOption = index => {
    setSelectedAnswer(index)
  }

  if (answers.length === 0) return null;

  return <>
    <Row>
      <Col size="12" className="flex justify-center">
        <h3>{stringToHtmlParser(question || '')}</h3>
      </Col>
    </Row>
    {isConsentBefore && <Row className="mt-2">
      <Col size="12" className="flex justify-center">
        <ConsentText consentTextActive={consentTextActive} consentText={consentText} />
      </Col>
    </Row>}
    <Options disabled={disabled} onClickOption={handleClickOption} data={data} />
    <Select data={data} />
    {!isConsentBefore && <Row className="mt-2" >
      <Col size="12" className="flex justify-center">
        <ConsentText consentTextActive={consentTextActive} consentText={consentText} />
      </Col>
    </Row>}
    <OptionProperties selectedAnswer={selectedAnswer} onChange={onChange} disabled={disabled} open={selectedAnswer !== null} onClose={() => setSelectedAnswer(null)} answers={answers} />
  </>
}
